<template>
<v-dialog
      v-model="showDialog"
      width="500"
    >
      <!-- <v-btn
        slot="activator"
        color="red lighten-2"
        dark
      >
        Click Me
      </v-btn> -->

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
         Notification
        </v-card-title>

        <v-card-text>
          {{message.title}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="showDialog = false"
          >
           Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
    <script>
  export default {
    props: ['message','showDialog'],
    data () {
      return {
        
      }
    }
  }
</script>